var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "external-api-field" }, [
    _c("div", { staticClass: "header-field" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "close-modal", on: { click: _vm.closeModal } }, [
        _vm._v("\n      ×\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "external-api-content" }, [
      _c(
        "div",
        { staticClass: "content-section" },
        [
          _c("p", { staticClass: "title-section" }, [_vm._v("Endpoint")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "b-form",
                    {
                      class: { "error-input": _vm.$v.dataSetup.method.$error }
                    },
                    [
                      _c("label", [_vm._v(" Method ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.methodOptions,
                          placeholder: "Select",
                          label: "label"
                        },
                        model: {
                          value: _vm.$v.dataSetup.method.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.dataSetup.method, "$model", $$v)
                          },
                          expression: "$v.dataSetup.method.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "9" } },
                [
                  _c(
                    "b-form",
                    { class: { "error-input": _vm.$v.dataSetup.url.$error } },
                    [
                      _c("label", [_vm._v(" URL ")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { placeholder: "Enter URL/Endpoint" },
                        model: {
                          value: _vm.$v.dataSetup.url.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.dataSetup.url, "$model", $$v)
                          },
                          expression: "$v.dataSetup.url.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form",
            { class: { "error-input": _vm.$v.dataSetup.source.$error } },
            [
              _c("label", [_vm._v(" Variable Source ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { placeholder: "Enter Variable Source" },
                model: {
                  value: _vm.$v.dataSetup.source.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.dataSetup.source, "$model", $$v)
                  },
                  expression: "$v.dataSetup.source.$model"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-section" },
        [
          _c("p", { staticClass: "title-section" }, [_vm._v("Header")]),
          _vm._v(" "),
          _vm._l(_vm.dataSetup.header, function(data, index) {
            return _c("div", { key: index + 0, staticClass: "form-list" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: data.name,
                    expression: "data.name"
                  }
                ],
                staticClass: "name",
                attrs: { type: "text", placeholder: "Name" },
                domProps: { value: data.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(data, "name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: data.value,
                    expression: "data.value"
                  }
                ],
                staticClass: "value",
                attrs: { type: "text", placeholder: "Value" },
                domProps: { value: data.value },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(data, "value", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-trash",
                on: {
                  click: function($event) {
                    _vm.deleteHeader(index)
                  }
                }
              })
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-add-config", on: { click: _vm.addHeader } },
            [_vm._v("\n        + Add Header\n      ")]
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.dataSetup.method === "GET"
        ? _c(
            "div",
            { staticClass: "content-section border-0" },
            [
              _c("p", { staticClass: "title-section" }, [_vm._v("Params")]),
              _vm._v(" "),
              _vm._l(_vm.dataSetup.params, function(data, index) {
                return _c("div", { key: index + 0, staticClass: "form-list" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: data.variable,
                        expression: "data.variable"
                      }
                    ],
                    staticClass: "name",
                    attrs: { type: "text", placeholder: "Variable" },
                    domProps: { value: data.variable },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(data, "variable", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: data.value,
                        expression: "data.value"
                      }
                    ],
                    staticClass: "value",
                    attrs: { type: "text", placeholder: "Value" },
                    domProps: { value: data.value },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(data, "value", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa fa-trash",
                    on: {
                      click: function($event) {
                        _vm.deleteParams(index)
                      }
                    }
                  })
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-add-config", on: { click: _vm.addParams } },
                [_vm._v("\n        + Add Params\n      ")]
              )
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "content-section border-0" },
            [
              _vm.showEditor
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form",
                            [
                              _c("label", [_vm._v(" Body ")]),
                              _vm._v(" "),
                              _c("j-monaco-editor", {
                                ref: "scriptBody",
                                attrs: {
                                  value: _vm.dataSetup.payload.body,
                                  height: "200px"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "external-api-footer" }, [
      _c(
        "button",
        { staticClass: "button-border mr-2", on: { click: _vm.closeModal } },
        [_vm._v("\n      Close\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "button-blue", on: { click: _vm.submitForm } },
        [_vm._v("\n      Set\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "icon-ext-api" }, [
        _c("img", {
          attrs: { src: require("@/assets/new-form-ui/ext-api.svg") }
        })
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "title-field" }, [_vm._v("External API")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-235ccdca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235ccdca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalExternalApiField.vue
// module id = null
// module chunks = 